import Header from "../../components/private/header";
import Navigation from "../../components/private/navigation";
import Main from "../../components/private/main";
import Photos from "../../components/private/photos";
import Footer from "../../components/private/footer";
import { getAuth } from "../../components/utils/auth";
import PhotoType from "../../components/private/phototype";

export default () => {
  const user = getAuth();

  return (
    <>
      <Header user={user} />
      <Navigation />
      <Main content={<PhotoType user={user} />} />
      <Footer />
    </>
  );
};
